'use strict';

/* eslint no-undef: "off" */
/**
 * newsletter content
 */
define('homeNewsletter',['homeNewsletterApi', 'util', 'transitionForEn', 'busEvent', 'GAReport'], function (homeNewsletterApi, Util, transitionForEn, busEvent, GAReport) {
  return {
    template: '\n      <div class="in-home-newsletter">\n        <form class="xp-newsletter-panel" @submit.prevent="validateBeforeSubmit">\n          <div class="xp-newsletter-heading">\n            <h6 v-text="i18n.title"></h6>\n            <p v-text="i18n.description"></p>\n          </div>\n\n          <div class="xp-newsletter-field" :class="{\'is-danger\': errors.has(i18n.email) }">\n            <input\n              type="text"\n              :name="i18n.email"\n              v-model="newsletter"\n              :placeholder="i18n.pleaseEmail"\n              autocomplete="off"\n              v-validate="\'required|email\'"\n            />\n            <button type="submit" v-text="i18n.subscribe"></button>\n          </div>\n        </form>\n      </div>\n    ',
    data: function data() {
      return {
        i18n: {
          title: 'sign up for luckydraw',
          description: 'exclusive offer for new member',
          pleaseEmail: 'Enter your email address',
          subscribe: 'subscribe',
          email: 'email'
        },
        newsletter: '',
        modalMsg: ''
      };
    },
    created: function created() {
      this.initTransition();
    },

    methods: {
      validateBeforeSubmit: function validateBeforeSubmit() {
        var _this = this;

        this.$validator.validateAll().then(function (result) {
          if (result) {
            return _this.submit();
          } else {
            _this.showPopBox(_this.errors.all()[0]);
          }
        });
      },
      submit: function submit() {
        var _this2 = this;

        // this.showLoadingEvent()
        homeNewsletterApi({
          email: this.newsletter
        }).then(function (resData) {
          _this2.showPopBox(resData.msg);
        });

        new GAReport().customerClick({
          eventAction: 'TOP_SUBSCRIBTION_SUBMIT',
          eventCategory: 'TOP_SUBSCRIBTION_#VERSION#'
        });
      },

      /**
       * 注入英文翻译
       */
      initTransition: function initTransition() {
        this.$validator.localize('en', {
          messages: transitionForEn.messages
        });
      },
      showPopBox: function showPopBox(msg) {
        busEvent.$emit('showPopBoxUpEvent', msg);
      }
    }
  };
});
